import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import moment from "moment";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { sweetAlert } from "../../Common/Utills/Utills";
import AddProductsModal from "./AddProductsModal";
import UpdateProductModal from "./UpdateProductModal";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import _ from "lodash";

const Products = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [rowAddData, setRowAddData] = useState({
    product_name: "",
    quantity: "",
    size: "",
    date: "",
  });
  const formRef = useRef(null);
  const [filterCriteria, setfilterCriteria] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData(() => {
        return {
          ...selectedRowsData,
          [name]: value,
        };
      });
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { product_name, quantity, size, date } = rowAddData;
    const renewalDate = moment.utc(date, "YYYY-MM-DD").toISOString();
    let BASE_URL = SERVER_URL + `/api/raw-mat/products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_name,
        quantity,
        size,
        date: renewalDate,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      console.log(response);
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/product/all-products/${user_id}`;
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(
        result.data.map((item, index) => {
          return {
            ...item,
            date: moment.utc(item.date).format("YYYY-MM-DD").toString(),
          };
        })
      );

      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  useEffect(() => {
    if (check) {
      if (loadingOverlayVisible) {
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        }
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);

  // const addData = (newData) => {
  //   console.log("Adding data:", newData);
  //   setRowData((prevData) => [...prevData, newData]);
  // };

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
    // setRowData((prevData) =>
    //   prevData.map((row) => (row === params.data ? updatedData : row))
    // );
    // console.log("Updated data:", updatedData);
  };
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    if (selectedNodes?.length > 1) {
      setRmvBtn(true);
    }
    if (selectedNodes?.length < 2) {
      setRmvBtn(false);
    }
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  }, []);

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if(res.ok){
      setCompany(result.data);
    }else{
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };

  const deleteRow = async (id) => {
    const message = "Do you want to delete this product!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL = SERVER_URL + `/api/product/products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
        };
      });
      getData();
    } else {
      toast.error(response.message);
      getData();
      setfilterCriteria((prevFilterCriteria) => {
        return {
          ...prevFilterCriteria,
        };
      });
    }
  };

  const addDataToModal = async (rowData) => {
    setselectedRowsData(rowData);
  };
  const updateData = async (rowData) => {
    const { id, product_name, size, company_id } = rowData;
    // const renewalDate = moment.utc(date, "YYYY-MM-DD").toISOString();
    let BASE_URL = SERVER_URL + `/api/product/products/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id,
        product_name,
        size,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        getData()
        formRef.current.reset();
      }, 1000);
    } else {
      toast.error(response.message);
      // getData();
    }
  };
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 100,
      minWidth: 100,
    },
    // {
    //   headerName: "Company",
    //   field: "company.company_name",
    //   valueFormatter: (params) => {
    //     const location = params.data.company.location;
    //     const type = params.data.company.type;
    //     return `${params.value} ${type} - ${location}`;
    //   },
    //   editable: false,
    //   width: 150,
    //   minWidth: 150,
    // },
    // {
    //   headerName: "Party Name",
    //   field: "partyName.party_name",
    //   editable: false,
    //   width: 150,
    //   minWidth: 150,
    // },
    // {
    //   headerName: "Raw Material",
    //   field: "raw_material.material_name",
    //   editable: false,
    //   width: 150,
    //   minWidth: 150,
    // },
    {
      headerName: "Product Name",
      field: "product_name",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Size",
      field: "size",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Company Name",
      field: "companyDetails.company_name",
      valueFormatter: (params) => {
        const location = params.data.companyDetails.location;
        return `${params.value}, ${location}`;
      },
      editable: false,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Date",
    //   field: "date",
    //   editable: true,
    //   width: 150,
    //   minWidth: 150,
    //   cellEditor: "agDateStringCellEditor",
    // },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => deleteRow(params.data.id)}
          >
            <i className="mdi mdi-delete" />
          </button>{" "}
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => addDataToModal(params.data)}
            data-toggle="modal"
            data-target="#updateProductModal"
          >
            <i className="mdi mdi-note-edit-outline" />
          </button>
        </>
      ),
      minWidth: 205,
    },
  ]);

  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
    flex: 1,
    headerPosition: "sticky",
  }));
  const gridOptions = useMemo(
    () => ({
      rowSelection: "multiple",
      suppressRowClickSelection: true,
      suppressCellSelection: true,
    }),
    []
  );
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({ company_id: "" });
    setSelectedCompanyId({ company_id: "" });
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Products Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#productModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Products
              </button>
            </div>

            <div>
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div>
            <div className="search mb-3">
              <div className="row">
                {/* <div className="col-md-3">
                  <div className="form-group">
                  <Creatable
                              isClearable
                              onChange={handlePartyNameChange}
                              onCreateOption={handleCreate}
                              options={partyNameOptions}
                              value={selectedPartyName}
                              // menuIsOpen={true}
                              menuPosition="fixed"
                            />
                  </div>
                </div> */}
                <div className="col-md-3">
                  <div className="form-group">
                    <select
                      className="form-control form-control-lg"
                      onChange={handleCompanyChange}
                      value={selectedCompanyId}
                    >
                      <option value="">Select Company (All)</option>
                      {company &&
                        company?.length > 0 &&
                        company?.map((item, id) => {
                          return (
                            <React.Fragment key={id}>
                              <option
                                value={item.id}
                                key={id}
                              >{`${item.company_name}, ${item.location}`}</option>
                            </React.Fragment>
                          );
                        })}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddProductsModal
            handleChange={handleChange}
            //   setimgfile={setimgfile}
            handleAddDataSubmit={handleAddDataSubmit}
            formRef={formRef}
            getData={getData}
          />
          <UpdateProductModal
            selectedRowsData={selectedRowsData}
            updateHandleChange={updateHandleChange}
            updateData={updateData}
            getData={getData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default Products;
